export type OptionMap = Record<string, string>

export const yesNoOptions: OptionMap = { yes: 'Ja', no: 'Nee' }

export const isOwnerOptions: OptionMap = {
  yes: 'Ja, ik ben eigenaar',
  no: 'Nee, ik ben medewerker/anders',
}

export const isDecisionMakerOptions: OptionMap = {
  yes: 'Ja, ik neem de beslissingen',
  no: 'Nee, ik overleg met anderen',
}

export const showTeamOptions: OptionMap = {
  yes: 'Ja, we willen een teampagina',
  no: 'Nee, dat is niet nodig',
  later: 'Weet ik nog niet / later beslissen',
}

export const teamPhotosOptions: OptionMap = {
  yes: "Ja, ik heb foto's",
  no_need_shoot: "Nee, ik moet nog foto's maken",
  no_later: 'Nee, die lever ik later aan',
}

export const multipleLocationsOptions: OptionMap = {
  yes: 'Ja, meerdere locaties',
  no: 'Nee, één locatie',
}

export const locationStrategyOptions: OptionMap = {
  separate_website: 'Een aparte website per locatie',
  separate_page: 'Een aparte pagina per locatie op dezelfde website',
  mention_only:
    'Eén website met alleen benoeming van de locaties (bijv. in de footer)',
  no_mention: 'Geen benoeming van specifieke locaties',
  specific_only: 'Alleen specifieke locaties benoemen, andere niet',
}

export const locationShowOptions: OptionMap = {
  yes: 'Ja, tonen',
  no: 'Nee, verbergen',
}

export const companyFeelOptions: OptionMap = {
  professional: 'Professioneel & Zakelijk',
  modern: 'Modern & Innovatief',
  luxury: 'Luxe & Premium',
  approachable: 'Toegankelijk & Vriendelijk',
  expert: 'Autoriteit & Expert',
  playful: 'Speels & Creatief',
  calm: 'Rustig & Betrouwbaar',
  bold: 'Stoer & Opvallend',
  other: 'Anders',
}

export const hasLegalDocsOptions: OptionMap = {
  yes: 'Ja, ik heb deze documenten al',
  no: 'Nee, ik moet deze nog (laten) opstellen',
}

export const legalDocOptions: OptionMap = {
  algemene_voorwaarden: 'Algemene Voorwaarden',
  privacyverklaring: 'Privacyverklaring',
  cookiebeleid: 'Cookiebeleid',
  disclaimer: 'Disclaimer',
  retourbeleid: 'Retourbeleid',
  garantiebeleid: 'Garantiebeleid',
  klachtenprocedure: 'Klachtenprocedure',
  leveringsvoorwaarden: 'Leveringsvoorwaarden',
  verwerkersovereenkomst: 'Verwerkersovereenkomst',
  servicevoorwaarden: 'Servicevoorwaarden / SLA',
  overig: 'Overige documenten',
}

export const legalApproachOptions: OptionMap = {
  noord: 'Noord Digital helpt mij hierbij',
  advisor: 'Ik schakel zelf een juridisch adviseur in',
  self: 'Ik stel ze zelf op',
}

export const hasIdentityOptions: OptionMap = {
  yes_complete: 'Ja, ik heb een compleet logo en huisstijlhandboek',
  yes_partly: 'Ja, ik heb een logo maar verder geen vaste stijl',
  no: 'Nee, Noord Digital mag een logo/huisstijl ontwerpen',
}

export const brandingAssetOptions: OptionMap = {
  logo: 'Logo',
  guidelines: 'Huisstijlhandboek',
}

export const typographyOptions: OptionMap = {
  inter: 'Inter',
  roboto: 'Roboto',
  montserrat: 'Montserrat',
  dm_sans: 'DM Sans',
  albert_sans: 'Albert Sans',
  nunito_sans: 'Nunito Sans',
  playfair: 'Playfair Display',
  merriweather: 'Merriweather',
  lora: 'Lora',
  cormorant: 'Cormorant Garamond',
  libre_baskerville: 'Libre Baskerville',
  poppins: 'Poppins',
  quicksand: 'Quicksand',
  comfortaa: 'Comfortaa',
  fredoka: 'Fredoka',
  baloo2: 'Baloo 2',
  source_sans: 'Source Sans 3',
  open_sans: 'Open Sans',
  work_sans: 'Work Sans',
  ibm_plex: 'IBM Plex Sans',
  barlow: 'Barlow',
  raleway: 'Raleway',
  josefin_sans: 'Josefin Sans',
  karla: 'Karla',
  manrope: 'Manrope',
  oswald: 'Oswald',
  bebas_neue: 'Bebas Neue',
  anton: 'Anton',
  russo_one: 'Russo One',
  advise: 'Geen voorkeur, Noord Digital adviseert',
}

export const mainGoalOptions: OptionMap = {
  leads: 'Leads genereren (offerte aanvragen, contactopnames)',
  sales: 'Directe verkoop (webshop, online boekingen)',
  info: 'Informatievoorziening (online visitekaartje, portfolio)',
  support: 'Klantenservice (FAQ, handleidingen, portaal)',
  employer: 'Personeel werven (vacatures, employer branding)',
  other: 'Anders',
}

export const websiteTypeOptions: OptionMap = {
  website: "Website (meerdere pagina's, geen productverkoop)",
  webshop: 'Webshop (winkelwagen en afrekenen)',
  onepager: 'Onepager (homepagina, evt. 1 extra pagina of blogs)',
}

export const needsPortalOptions: OptionMap = {
  yes: 'Ja, klanten moeten kunnen inloggen',
  no: 'Nee, dat is niet nodig',
}

export const pageOptions: OptionMap = {
  home: 'Home',
  contact: 'Contact',
  legal: "Juridische pagina's (Privacy, Voorwaarden)",
  about: 'Over ons',
  services: 'Diensten / Producten',
  team: 'Team',
  faq: 'Veelgestelde vragen (FAQ)',
  blog: 'Blog / Kennisbank',
  cases: 'Cases / Portfolio',
  vacancies: 'Werken bij / Vacatures',
  shop: 'Winkel / Productoverzicht',
  cart: 'Winkelwagen',
  checkout: 'Afrekenen',
  account: 'Mijn Account',
  extra_page: '1 Extra pagina (bijv. diensten of over ons)',
  other: 'Anders',
}

export const textContentOptions: OptionMap = {
  write_all: 'Noord Digital schrijft alles',
  rewrite: 'Klant levert teksten aan, Noord Digital redigeert',
  self: 'Klant schrijft en levert alle teksten zelf aan',
}

export const photoContentOptions: OptionMap = {
  have_photos: "Klant heeft professionele foto's beschikbaar",
  need_shoot: 'Fotoshoot inplannen via Noord Digital',
  stock: 'Gebruik (premium) stockfotografie',
}

export const toneOfVoiceOptions: OptionMap = {
  formal: 'Formeel (u-vorm, zakelijk)',
  informal: 'Informeel (je-vorm, toegankelijk)',
  mix: 'Mix (je-vorm maar wel professioneel)',
  advise: 'Weet ik niet, adviseer mij',
}

export const domainOwnedOptions: OptionMap = {
  yes: 'Ja, heeft al een domeinnaam',
  no: 'Nee, moet nog geregistreerd worden',
}

export const domainManagementOptions: OptionMap = {
  self: 'Beheert het zelf',
  third_party: 'Via een 3e partij',
}

export const offlineOptions: OptionMap = {
  yes: 'Ja, tijdelijk offline is geen probleem',
  no: 'Nee, liever niet (bouwen op staging omgeving)',
}

export const hostingOptions: OptionMap = {
  noord: 'Volledig ontzorgd via Noord Digital',
  external: 'Regelt zelf externe hosting (+10% kosten)',
}

export const seoImportanceOptions: OptionMap = {
  high: 'Zeer belangrijk',
  medium: 'Belangrijk',
  low: 'Niet zo belangrijk (standaard Yoast SEO basis)',
}

export const keywordResearchOptions: OptionMap = {
  extensive: 'Uitgebreid onderzoek (inclusief long-tail zoektermen)',
  small: 'Klein basis onderzoek',
  none: 'Niet nodig, klant weet de termen al',
}

export const seoSiloOptions: OptionMap = {
  yes: 'Ja, stel een silo in',
  no: 'Nee, niet nodig',
  dont_know: 'Weet ik niet, adviseer mij',
}

export const siloPackageOptions: OptionMap = {
  silver: 'Zilver — Regionale groei',
  gold: 'Goud — Ads + SEO data-loop',
  platinum: 'Platinum — Maatwerk & exclusief',
}

export const blogpostsOptions: OptionMap = {
  yes: 'Ja, graag',
  no: 'Nee, doet klant zelf',
}

export const blogFrequencyOptions: OptionMap = {
  daily: 'Elke dag',
  weekly: '1x per week',
  biweekly: '1x per twee weken',
  monthly: '1x per maand',
}

export const keywordUpdatesOptions: OptionMap = {
  monthly: 'Ja, maandelijks',
  yearly: 'Ja, jaarlijks',
  no: 'Nee, eenmalige setup is genoeg',
}

export const yesNoAdviseOptions: OptionMap = {
  yes: 'Ja',
  no: 'Nee',
  advise: 'Weet ik niet, adviseer mij',
}

export const trainingOptions: OptionMap = {
  yes: 'Ja, extra training',
  no: 'Nee, basis is voldoende',
}

export const businessProfileTaskOptions: OptionMap = {
  photos: "Foto's uploaden",
  blogs: 'Blogs / Updates plaatsen',
  info: 'Bedrijfsinformatie juist zetten',
}

export const socialAdsOptions: OptionMap = {
  instagram: 'Instagram',
  facebook: 'Facebook',
  tiktok: 'TikTok',
  linkedin: 'LinkedIn',
  pinterest: 'Pinterest',
}

export const websiteLanguagesOptions: OptionMap = {
  nl: 'Alleen Nederlands',
  nl_en: 'Nederlands + Engels',
  more: 'Meer talen',
}

export const yesNoUnknownOptions: OptionMap = {
  yes: 'Ja',
  no: 'Nee',
  unknown: 'Weet ik niet',
}

export const currentCmsOptions: OptionMap = {
  wordpress: 'WordPress',
  wix: 'Wix',
  squarespace: 'Squarespace',
  shopify: 'Shopify',
  other: 'Anders',
  unknown: 'Weet ik niet',
}

export const accessKnownOptions: OptionMap = {
  yes: 'Ja',
  partly: 'Deels',
  no: 'Nee',
}

export const integrationOptions: OptionMap = {
  crm: 'CRM',
  accounting: 'Boekhouding',
  newsletter: 'Nieuwsbrief (bijv. Mailchimp)',
  calendar: 'Agenda / online afspraken',
  chat: 'Chat / WhatsApp',
  none: 'Geen',
  other: 'Anders',
}

export const shippingCostOptions: OptionMap = {
  fixed: 'Vast bedrag',
  free_from: 'Gratis vanaf een bedrag',
  weight_zone: 'Per gewicht of zone',
  unknown: 'Weet ik niet',
}

export const launchDateOptions: OptionMap = {
  asap: 'Zo snel mogelijk',
  '4to6weeks': 'Binnen 4 tot 6 weken',
  '2to3months': 'Binnen 2-3 maanden',
  relaxed: 'Geen haast, kwaliteit voorop',
}
